/**
 * Includes the secondary menu list entries shown on the very left side.
 * Secondary list entries are shown in the menu section below the separator.
 */

import {List} from '@mui/material'
import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import {NavLink} from 'react-router-dom'

import {useStyles} from 'components/admin/navigation/navItems/AdminNavItems.css'
import {FormattedMessage} from 'react-intl';


const AdminNavItemsSecondary = () => {
    const classes = useStyles()

    return (
        <List>
            <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive} to={"/common/about"}>
                <ListItemIcon>
                    <InfoIcon />
                </ListItemIcon>
                <FormattedMessage id={'app.navigation.about'}
                                  defaultMessage={'About'}/>
            </ListItem>
            <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive} to={"/common/help"}>
                <ListItemIcon>
                    <HelpIcon />
                </ListItemIcon>
                <FormattedMessage id={'app.navigation.help'}
                                  defaultMessage={'help'}/>
            </ListItem>
        </List>
    )
}

export default AdminNavItemsSecondary
